// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
declare const require: any;


export const environment = {
  appVersion: require('../../package.json').version + '-dev',
  production: false,
  //credenciales para proveedores de pago
  /* dev */
  clientIdPaypal:
    'AUoZD4c0ErSbrhNCigEssgm20hKZFGzdvXBt8c2hbgSpZyQhCjp5hjDDOGCkWz7LW4VB6qw_ZIYzQXiC',

  /* pro */
  /*  clientIdPaypal:
    'AQKfKHraAm66VdPK7jjEwfpc3hvSdfxyIP9fQytTIFD4kZiO-jWZvFKPTpFPzs-ViARhlxuc05htM3rU',
   */

  clientIdMercadoPago: 'TEST-105920a2-1f2b-41a4-aab3-c6f9f7017651',

  apiUrl: 'https://coreapi.mutuus.click',
  urlToku: 'https://mutuus.trytoku.com/dashboard?user=',
  tokuPublicApiKey: 'OYp54NpHgI_LYDpF0YozqAulN8Q0xH37sqWxYSGoy3o',
  tokuPortalId: 0,

  // dev local (no commitear activo):
  //apiUrl: 'https://localhost:51502',
  uriAsociado: '/api/Asociado/',
  //catalogos end points



  //solicitud Digital
  solicitudDigital: '/api/SolicitudDigital/',
  getEstatusSoliciutud: '/api/SolicitudDigital/',


  getDataAntiguedad: '/api/SolicitudDigital/Antiguedad/',
  getHistorialClinico: '/api/Catalogos/CuestionarioMedico',

  postBeneficiarioData: '/api/Asociado/',

  getOrdenCompra: '/api/OrdenPago/',
  postMercadoPago: '/api/MercadoPago/',

  getHistorial: '/api/SolicitudDigital/',
  getOrdenPago: '/api/OrdenPago/',
  downloadComprbantePago: '/api/ExpedienteDigital/DescargaUri',

  //Urgencias
  getUrgencias: '/api/Urgencias',



  //usuarios
  getRoles: '/api/Usuarios/GetRoles',
  getUsuarios: '/api/Usuarios/GetUsuarioRole',
  postUsuario: '/api/Usuarios/Registrar',

  //Permisos
  getPermissions: '/api/Portal/Permisos/',

  AutoServicio: 'https://devonboarding.psmutuus.com/agente/',
  AuthRedirect: 'https://devonboarding.psmutuus.com/auth/redirect?token='

};
